import { useRoutes } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { useUser } from './UserContext';
import routes from './routes';

import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';

import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';


export default function App() {
  const { user } = useUser(); 
  const routing = useRoutes(routes(user)); 

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <SnackbarProvider>
          {routing}
      </SnackbarProvider>
    </ThemeConfig>
  );
}
